import { useEffect } from 'react'
import Animated, {
  useAnimatedStyle,
  useReducedMotion,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated'

import { DepositActionMotion } from '../components/DepositActionMotion'
import { PillButton, type PillButtonProps } from '../components/PillButton'
import {
  ACTION_ENTER_TIMING,
  ACTION_ENTER_TRAVEL,
  ACTION_EXITING,
} from '../utils/motion'

export function FiatActionButton(props: PillButtonProps) {
  const reduceMotion = useReducedMotion()
  // One value for both halves of the arrival, so the fade and the rise cannot
  // drift apart.
  const arrival = useSharedValue(reduceMotion ? 1 : 0)
  useEffect(() => {
    arrival.value = reduceMotion ? 1 : 0
    if (!reduceMotion) {
      arrival.value = withTiming(1, ACTION_ENTER_TIMING)
    }
  }, [reduceMotion, arrival])
  const entrance = useAnimatedStyle(() => {
    'worklet'
    return {
      opacity: arrival.value,
      transform: [{ translateY: (1 - arrival.value) * ACTION_ENTER_TRAVEL }],
    }
  })

  return (
    // Leaving is a keyframe rather than the shared value: the view is gone by
    // the time a value could run, and whatever takes the slot rises into it.
    <Animated.View style={entrance} exiting={ACTION_EXITING}>
      <DepositActionMotion.Provider value>
        <PillButton {...props} />
      </DepositActionMotion.Provider>
    </Animated.View>
  )
}
